import React from 'react';

export type TierGroup = {
  /** Label shown in first column, e.g. "Pot 1", "Tier A" */
  tier: string;
  teams: string[];
  notes?: string;
};

type TierTeamsTableProps = {
  groups: TierGroup[];
  caption?: string;
  /** Column header for the tier/pot column */
  tierColumnLabel?: string;
};

function TierTeamsTable({ groups, caption, tierColumnLabel = 'Tier / pot' }: TierTeamsTableProps) {
  return (
    <div className="wc26-table-scroll">
      <table className="wc26-table wc26-tier-table">
        {caption ? <caption>{caption}</caption> : null}
        <thead>
          <tr>
            <th scope="col">{tierColumnLabel}</th>
            <th scope="col">Teams</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((g) => (
            <tr key={g.tier}>
              <th scope="row" className="wc26-tier-label">
                {g.tier}
              </th>
              <td>
                <ul className="wc26-team-pills">
                  {g.teams.map((team) => (
                    <li key={`${g.tier}-${team}`}>{team}</li>
                  ))}
                </ul>
                {g.notes ? <p className="wc26-tier-notes">{g.notes}</p> : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TierTeamsTable;
